module.exports = "### React\n\n- Same time Facebook buys photo sharing startup\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_7.md
// module id = 1488
// module chunks = 0